/**
 * Action types for captive portal functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle list of captive portals.
 */

// Get captive portals constants
export const CAPTIVE_PORTALS_REQUEST_GET = 'CAPTIVE_PORTALS_REQUEST_GET';
export const CAPTIVE_PORTALS_RESPONSE_GET_SUCCESS = 'CAPTIVE_PORTALS_RESPONSE_GET_SUCCESS';
export const CAPTIVE_PORTALS_RESPONSE_GET_FAIL = 'CAPTIVE_PORTALS_RESPONSE_GET_FAIL'

/**
 * Action types for post captive portal data.
 *
 * These constants represent different stages of the captive portal data adding process
*/
export const CAPTIVE_PORTAL_REQUEST_ADD = 'CAPTIVE_PORTAL_REQUEST_ADD';
export const CAPTIVE_PORTAL_ADDED_SUCCESFULLY = 'CAPTIVE_PORTAL_CREATED_SUCCESSFULLY';
export const CAPTIVE_PORTAL_RESPONSE_ADD_SUCCESS = 'CAPTIVE_PORTAL_RESPONSE_ADD_SUCCESS';
export const CAPTIVE_PORTAL_ADD_SUCCESS_MESSAGE = 'Captive Portal Added Successfully';
export const CAPTIVE_PORTAL_RESPONSE_ADD_FAIL = 'CAPTIVE_PORTAL_RESPONSE_ADD_FAIL';
export const RESET_CAPTIVE_PORTAL_ADD = 'RESET_CAPTIVE_PORTAL_ADD';

export const SET_CAPTIVE_PORTAL_NAME = 'SET_CAPTIVE_PORTAL_NAME';
export const SET_SELECT_PLAN_NAME = 'SET_SELECT_PLAN_NAME';
export const SET_TYPE = 'SET_TYPE';
export const SET_SPLASH_URL = 'SET_SPLASH_URL';
export const SET_HOME_PAGE_URL = 'SET_HOME_PAGE_URL';
export const SET_IOCP = 'SET_IOCP';
export const SET_EXT_SERVER_IP = 'SET_EXT_SERVER_IP';
export const SET_ENCRYPTION = 'SET_ENCRYPTION';
export const SET_ENCRYPTION_PASSKEY = 'SET_ENCRYPTION_PASSKEY';
export const SET_SELECT_PLAN = 'SET_SELECT_PLAN';
export const SET_MOBILE_LOGO_POSITION = 'SET_MOBILE_LOGO_POSITION';
export const SET_MOBILE_TILE_POSITION = 'SET_MOBILE_TILE_POSITION';
export const SET_WALLED_GARDEN_ENABLE = 'SET_WALLED_GARDEN_ENABLE';
export const SET_WHITE_LIST_URL = 'SET_WHITE_LIST_URL';
export const SET_SECURE_LOGON = 'SET_SECURE_LOGON';
export const SET_RADIUS_SERVER_ID = 'SET_RADIUS_SERVER_ID';

export const CAPTIVE_PORTAL_REQUEST_PUT = 'CAPTIVE_PORTAL_REQUEST_PUT';
export const CAPTIVE_PORTAL_RESPONSE_PUT_FAIL = 'CAPTIVE_PORTAL_RESPONSE_PUT_FAIL';
export const DELETE_CAPTIVE_PORTAL_RESPONSE_SUCCESS = 'DELETE_CAPTIVE_PORTAL_RESPONSE_SUCCESS';
export const RESET_CAPTIVE_PORTAL_DELETE = 'RESET_CAPTIVE_PORTAL_DELETE';
export const CAPTIVE_PORTAL_SELECTED = 'CAPTIVE_PORTAL_SELECTED'
export const CAPTIVE_PORTAL_SELECTED_BULK = 'CAPTIVE_PORTAL_SELECTED_BULK'
export const CAPTIVE_PORTAL_PROFILE_DELETED_SUCCESSFULLY = 'CAPTIVE_PORTAL_PROFILE_DELETED_SUCCESSFULLY'

export const GET_SPLASH_ID = 'GET_SPLASH_ID';
export const SET_LOGO_ONE = 'SET_LOGO_ONE';
export const SET_LOGO_ONE_CONFIG = 'SET_LOGO_ONE_CONFIG';
export const SET_LOGO_TWO = 'SET_LOGO_TWO';
export const SET_LOGO_TWO_CONFIG = 'SET_LOGO_TWO_CONFIG';
export const SET_BACKGROUND = 'SET_BACKGROUND';
export const ENABLE_TERMS_CONDITIONS = 'ENABLE_TERMS_CONDITIONS';
export const SET_TERMS_CONDITIONS = 'SET_TERMS_CONDITIONS';
export const SET_TERMS_CONDITIONS_CONFIG = 'SET_TERMS_CONDITIONS_CONFIG';
export const SET_TITLE_ONE_CONFIG = 'SET_TITLE_ONE_CONFIG';
export const SET_TITLE_TWO_CONFIG = 'SET_TITLE_TWO_CONFIG';
export const SET_TITLE_THREE_CONFIG = 'SET_TITLE_THREE_CONFIG';
export const SET_TILE_POSITION = 'SET_TILE_POSITION';
export const SET_AUTHENTICATION_TYPE_CONFIG = 'SET_AUTHENTICATION_TYPE_CONFIG';

export const CAPTIVE_PORTAL_REQUEST_PATCH = 'CAPTIVE_PORTAL_REQUEST_PATCH';
export const CAPTIVE_PORTAL_RESPONSE_PATCH_FAIL = 'CAPTIVE_PORTAL_RESPONSE_PATCH_FAIL';
export const EDIT_CAPTIVE_PORTAL_RESPONSE_SUCCESS = 'EDIT_CAPTIVE_PORTAL_RESPONSE_SUCCESS';
export const CAPTIVE_PORTAL_PROFILE_UPDATED_SUCCESSFULLY = 'CAPTIVE_PORTAL_PROFILE_UPDATED_SUCCESSFULLY';
export const GET_CAPTIVE_ID = 'GET_CAPTIVE_ID';
export const GET_AUTH_MODE = 'GET_AUTH_MODE';
export const GET_UAM_PORT = 'GET_UAM_PORT';
export const GET_UAM_SECRET = 'GET_UAM_SECRET';
export const GET_IDLE_TIMEOUT = 'GET_IDLE_TIMEOUT';
export const GET_TIMEOUT = 'GET_TIMEOUT';
export const GET_CAPTIVE_VENDOR = 'GET_CAPTIVE_VENDOR';

export const RESET_CAPTIVE_PORTAL_EDIT = 'RESET_CAPTIVE_PORTAL_EDIT';
export const GET_LB_IP = 'GET_LB_IP';
export const CAPTIVE_PORTAL_PROFILE_ADDED_SUCCESSFULLY = 'CAPTIVE_PORTAL_PROFILE_ADDED_SUCCESSFULLY';
export const sampleTC = 
'By accessing and using the Wi-Fi service provided by HFCL Limited, you agree to the following terms and conditions.This Service is intended for personal, lawful use only. You must not use it for any unlawful purpose or to transmit any material that is offensive, harmful, or violates the rights of others. HFCL Limited does not guarantee that the Service will be secure, uninterrupted, or free of errors, and access may be restricted or terminated at any time without notice. This is a public network, and you use it at your own risk. We strongly recommend that you avoid accessing sensitive personal data or conducting financial transactions while connected. HFCL Limited is not liable for any loss, damage, or inconvenience caused by your use of the Service, including data breaches, identity theft, or service interruptions.By using the Service, you also consent to the limited collection of non-personal information such as device type, connection duration, and basic browsing activity, as outlined in our Privacy Policy. We do not collect personal data unless voluntarily provided. HFCL Limited may update these terms at any time, and continued use of the Service indicates your acceptance of the revised terms. If you do not agree to these terms, please do not use the Wi-Fi. For further information, please refer https://io.hfcl.com/terms-of-service.';
export const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
export const ipv4RegexWhitelistUrl = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;
export const domainRegex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+(com|net|org|edu|gov|co|io|in|uk|us|info|biz|me|dev)$/i;
export const validUrlRegex = /^(https?:\/\/)(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}|((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}))(:\d+)?(\/[^\s]*)?$/i;
export const alphaNumericWOSpace = /^[a-zA-Z0-9]{1,32}$/;